import {
  SupportRequestChange,
  SupportRequestEvent,
  SupportRequestPage,
  SupportRequestType,
} from '../support-system.models';

/** Glyphs drawn inline (support-requests-dialog.component.html). */
export type RequestIcon =
  | 'toggle'
  | 'pencil'
  | 'warning'
  | 'chart'
  | 'bulb'
  | 'calendar'
  | 'person-add'
  | 'question';

export type RequestGroup = 'nudges' | 'results' | 'account';

/**
 * What one request type asks for. Its texts are under
 * `support_requests.types.<type>` (title, hint, form, sub, desc, ph).
 */
export interface RequestTypeDef {
  type: SupportRequestType;
  group: RequestGroup;
  icon: RequestIcon;
  /** Tile icon colours: indigo by default. */
  tone?: 'warn' | 'neutral';
  /** "Which nudges?": its hint says Optional, or "ID or name". */
  nudges?: 'optional' | 'named';
  /** "Where on the site?" chips. */
  pages?: boolean;
  attachments: boolean;
  messageRequired: boolean;
  /** Sends the activity history, so the team sees what led up to it. */
  diagnostics?: boolean;
}

/** In the order the first screen shows them. */
export const REQUEST_TYPES: RequestTypeDef[] = [
  {
    type: 'toggle',
    group: 'nudges',
    icon: 'toggle',
    nudges: 'named',
    attachments: true,
    messageRequired: false,
  },
  {
    type: 'change',
    group: 'nudges',
    icon: 'pencil',
    nudges: 'named',
    attachments: true,
    messageRequired: true,
  },
  {
    type: 'broken',
    group: 'nudges',
    icon: 'warning',
    tone: 'warn',
    nudges: 'optional',
    attachments: true,
    messageRequired: true,
    diagnostics: true,
  },
  { type: 'data', group: 'results', icon: 'chart', attachments: true, messageRequired: true },
  {
    type: 'idea',
    group: 'results',
    icon: 'bulb',
    pages: true,
    attachments: true,
    messageRequired: true,
  },
  { type: 'headsup', group: 'results', icon: 'calendar', attachments: true, messageRequired: false },
  { type: 'access', group: 'account', icon: 'person-add', attachments: false, messageRequired: false },
  {
    type: 'other',
    group: 'account',
    icon: 'question',
    tone: 'neutral',
    attachments: true,
    messageRequired: true,
  },
];

export const REQUEST_GROUPS: RequestGroup[] = ['nudges', 'results', 'account'];

export function requestType(type: SupportRequestType): RequestTypeDef {
  return REQUEST_TYPES.find((t) => t.type === type)!;
}

/* Chip and select options; labels under support_requests.<list>.<key>. */

export const REQUEST_PAGES: SupportRequestPage[] = [
  'homepage',
  'category',
  'product',
  'search',
  'cart',
  'checkout',
  'other',
];
export const REQUEST_CHANGES: SupportRequestChange[] = [
  'text',
  'design',
  'placement',
  'products',
  'coupon',
  'other',
];
export const REQUEST_EVENTS: SupportRequestEvent[] = [
  'sale',
  'relaunch',
  'outage',
  'campaign',
  'other',
];
/** What a colleague can be given access to (sidenav product titles). */
export const REQUEST_ACCESS_PRODUCTS = [
  'Nudge',
  'Signals',
  'Diagnostic',
  'User Insights',
  'Organic',
  'Merchandise',
];
